import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { apiFetch } from '../api';
import { getUser } from '../auth';

function NotificationQuickButton() {
  const navigate = useNavigate();
  const location = useLocation();
  const user = getUser();

  const [count, setCount] = useState(0);
  const [checking, setChecking] = useState(false);

  const isLoginPage = location.pathname === '/login';

  const loadUnreadCount = async () => {
    if (!user || isLoginPage) return;

    try {
      setChecking(true);
      const response = await apiFetch('/notifications/unread-count');

      if (!response || !response.ok) return;

      const data = await response.json();
      setCount(Number(data.count || 0));
    } catch {
      // لا نزعج المستخدم عند فشل الفحص الخفيف
    } finally {
      setChecking(false);
    }
  };

  useEffect(() => {
    if (!user || isLoginPage) return;

    loadUnreadCount();

    const interval = setInterval(loadUnreadCount, 45000);

    const refreshHandler = () => loadUnreadCount();
    window.addEventListener('focus', refreshHandler);
    window.addEventListener('eshara-refresh-notifications', refreshHandler);

    return () => {
      clearInterval(interval);
      window.removeEventListener('focus', refreshHandler);
      window.removeEventListener('eshara-refresh-notifications', refreshHandler);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.id, isLoginPage]);

  if (!user || isLoginPage) {
    return null;
  }

  return (
    <button
      type="button"
      onClick={() => navigate('/notifications')}
      className="fixed bottom-4 left-4 z-50 bg-gray-950 hover:bg-black text-white shadow-lg rounded-2xl px-4 py-3 font-bold text-sm flex items-center gap-2 border border-white/10"
      title="فتح إشعارات النظام"
    >
      <span className={checking ? 'animate-pulse' : ''}>🔔</span>
      <span>الإشعارات</span>

      {count > 0 && (
        <span className="min-w-[24px] h-6 px-2 rounded-full bg-orange-500 text-white text-xs flex items-center justify-center">
          {count > 99 ? '99+' : count}
        </span>
      )}
    </button>
  );
}

export default NotificationQuickButton;
